import "core-js/modules/es.array.unscopables.flat.js";
import { ChaCha20Poly1305 as ie } from "@stablelib/chacha20poly1305";
import { HKDF as pn } from "@stablelib/hkdf";
import { randomBytes as ce } from "@stablelib/random";
import { SHA256 as mn, hash as ae } from "@stablelib/sha256";
import * as ue from "@stablelib/x25519";
import { toString as E, fromString as v, concat as de } from "uint8arrays";
import { detect as yn } from "detect-browser";
import { toMiliseconds as G, FIVE_MINUTES as le, fromMiliseconds as hn } from "@walletconnect/time";
import { getDocument as En, getNavigator as fe, getLocation as pe } from "@walletconnect/window-getters";
import { getWindowMetadata as vn } from "@walletconnect/window-metadata";
import * as V from "query-string";
import { RELAY_JSONRPC as gn } from "@walletconnect/relay-api";
const k = ":";
function me(e) {
  const [n, t] = e.split(k);
  return {
    namespace: n,
    reference: t
  };
}
function ye(e) {
  const {
    namespace: n,
    reference: t
  } = e;
  return [n, t].join(k);
}
function W(e) {
  const [n, t, r] = e.split(k);
  return {
    namespace: n,
    reference: t,
    address: r
  };
}
function he(e) {
  const {
    namespace: n,
    reference: t,
    address: r
  } = e;
  return [n, t, r].join(k);
}
function z(e, n) {
  const t = [];
  return e.forEach(r => {
    const o = n(r);
    t.includes(o) || t.push(o);
  }), t;
}
function Ee(e) {
  const {
    address: n
  } = W(e);
  return n;
}
function ve(e) {
  const {
    namespace: n,
    reference: t
  } = W(e);
  return ye({
    namespace: n,
    reference: t
  });
}
function bn(e, n) {
  const {
    namespace: t,
    reference: r
  } = me(n);
  return he({
    namespace: t,
    reference: r,
    address: e
  });
}
function Nn(e) {
  return z(e, Ee);
}
function ge(e) {
  return z(e, ve);
}
function On(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const t = [];
  return Object.keys(e).forEach(r => {
    if (n.length && !n.includes(r)) return;
    const o = e[r];
    t.push(...o.accounts);
  }), t;
}
function Sn(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const t = [];
  return Object.keys(e).forEach(r => {
    if (n.length && !n.includes(r)) return;
    const o = e[r];
    t.push(...ge(o.accounts));
  }), t;
}
function In(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const t = [];
  return Object.keys(e).forEach(r => {
    if (n.length && !n.includes(r)) return;
    const o = e[r];
    t.push(...M(r, o));
  }), t;
}
function M(e, n) {
  return e.includes(":") ? [e] : n.chains || [];
}
const K = e => e === null || e === void 0 ? void 0 : e.split(":"),
  be = e => {
    const n = e && K(e);
    if (n) return n[3];
  },
  Pn = e => {
    const n = e && K(e);
    if (n) return n[2] + ":" + n[3];
  },
  Ne = e => {
    const n = e && K(e);
    if (n) return n.pop();
  },
  Tn = (e, n) => {
    const t = "".concat(e.domain, " wants you to sign in with your Ethereum account:"),
      r = Ne(n),
      o = e.statement,
      s = "URI: ".concat(e.aud),
      i = "Version: ".concat(e.version),
      d = "Chain ID: ".concat(be(n)),
      l = "Nonce: ".concat(e.nonce),
      c = "Issued At: ".concat(e.iat),
      u = e.resources && e.resources.length > 0 ? "Resources:\n".concat(e.resources.map(a => "- ".concat(a)).join("\n")) : void 0;
    return [t, r, "", o, "", s, i, d, l, c, u].filter(a => a != null).join("\n");
  },
  B = "base10",
  p = "base16",
  L = "base64pad",
  x = "utf8",
  Y = 0,
  U = 1,
  wn = 0,
  Oe = 1,
  J = 12,
  Q = 32;
function Rn() {
  const e = ue.generateKeyPair();
  return {
    privateKey: E(e.secretKey, p),
    publicKey: E(e.publicKey, p)
  };
}
function An() {
  const e = ce(Q);
  return E(e, p);
}
function Un(e, n) {
  const t = ue.sharedKey(v(e, p), v(n, p)),
    r = new pn(mn, t).expand(Q);
  return E(r, p);
}
function _n(e) {
  const n = ae(v(e, p));
  return E(n, p);
}
function $n(e) {
  const n = ae(v(e, x));
  return E(n, p);
}
function Se(e) {
  return v("".concat(e), B);
}
function $(e) {
  return Number(E(e, B));
}
function jn(e) {
  const n = Se(typeof e.type < "u" ? e.type : Y);
  if ($(n) === U && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
  const t = typeof e.senderPublicKey < "u" ? v(e.senderPublicKey, p) : void 0,
    r = typeof e.iv < "u" ? v(e.iv, p) : ce(J),
    o = new ie(v(e.symKey, p)).seal(r, v(e.message, x));
  return Ie({
    type: n,
    sealed: o,
    iv: r,
    senderPublicKey: t
  });
}
function Cn(e) {
  const n = new ie(v(e.symKey, p)),
    {
      sealed: t,
      iv: r
    } = Z(e.encoded),
    o = n.open(r, t);
  if (o === null) throw new Error("Failed to decrypt");
  return E(o, x);
}
function Ie(e) {
  if ($(e.type) === U) {
    if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    return E(de([e.type, e.senderPublicKey, e.iv, e.sealed]), L);
  }
  return E(de([e.type, e.iv, e.sealed]), L);
}
function Z(e) {
  const n = v(e, L),
    t = n.slice(wn, Oe),
    r = Oe;
  if ($(t) === U) {
    const d = r + Q,
      l = d + J,
      c = n.slice(r, d),
      u = n.slice(d, l),
      a = n.slice(l);
    return {
      type: t,
      sealed: a,
      iv: u,
      senderPublicKey: c
    };
  }
  const o = r + J,
    s = n.slice(r, o),
    i = n.slice(o);
  return {
    type: t,
    sealed: i,
    iv: s
  };
}
function Dn(e, n) {
  const t = Z(e);
  return Pe({
    type: $(t.type),
    senderPublicKey: typeof t.senderPublicKey < "u" ? E(t.senderPublicKey, p) : void 0,
    receiverPublicKey: n === null || n === void 0 ? void 0 : n.receiverPublicKey
  });
}
function Pe(e) {
  const n = (e === null || e === void 0 ? void 0 : e.type) || Y;
  if (n === U) {
    if (typeof (e === null || e === void 0 ? void 0 : e.senderPublicKey) > "u") throw new Error("missing sender public key");
    if (typeof (e === null || e === void 0 ? void 0 : e.receiverPublicKey) > "u") throw new Error("missing receiver public key");
  }
  return {
    type: n,
    senderPublicKey: e === null || e === void 0 ? void 0 : e.senderPublicKey,
    receiverPublicKey: e === null || e === void 0 ? void 0 : e.receiverPublicKey
  };
}
function Vn(e) {
  return e.type === U && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var kn = Object.defineProperty,
  Te = Object.getOwnPropertySymbols,
  Mn = Object.prototype.hasOwnProperty,
  Kn = Object.prototype.propertyIsEnumerable,
  we = (e, n, t) => n in e ? kn(e, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[n] = t,
  Re = (e, n) => {
    for (var t in n || (n = {})) Mn.call(n, t) && we(e, t, n[t]);
    if (Te) for (var t of Te(n)) Kn.call(n, t) && we(e, t, n[t]);
    return e;
  };
const Ae = "ReactNative",
  b = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
  },
  F = " ",
  Ln = ":",
  Ue = "/",
  X = 2,
  xn = 1e3,
  _e = "js";
function ee() {
  return typeof process < "u" && typeof process.versions < "u" && typeof process.versions.node < "u";
}
function $e() {
  return !En() && !!fe() && navigator.product === Ae;
}
function je() {
  return !ee() && !!fe();
}
function j() {
  return $e() ? b.reactNative : ee() ? b.node : je() ? b.browser : b.unknown;
}
function Ce(e, n) {
  let t = V.parse(e);
  return t = Re(Re({}, t), n), e = V.stringify(t), e;
}
function Fn() {
  return vn() || {
    name: "",
    description: "",
    url: "",
    icons: [""]
  };
}
function Hn(e, n) {
  var t;
  const r = j(),
    o = {
      protocol: e,
      version: n,
      env: r
    };
  return r === "browser" && (o.host = ((t = pe()) == null ? void 0 : t.host) || "unknown"), o;
}
function De() {
  if (j() === b.reactNative && typeof global < "u" && typeof (global == null ? void 0 : global.Platform) < "u") {
    const {
      OS: t,
      Version: r
    } = global.Platform;
    return [t, r].join("-");
  }
  const e = yn();
  if (e === null) return "unknown";
  const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
  return e.type === "browser" ? [n, e.name, e.version].join("-") : [n, e.version].join("-");
}
function Ve() {
  var e;
  const n = j();
  return n === b.browser ? [n, ((e = pe()) == null ? void 0 : e.host) || "unknown"].join(":") : n;
}
function ke(e, n, t) {
  const r = De(),
    o = Ve();
  return [[e, n].join("-"), [_e, t].join("-"), r, o].join("/");
}
function qn(_ref) {
  let {
    protocol: e,
    version: n,
    relayUrl: t,
    sdkVersion: r,
    auth: o,
    projectId: s,
    useOnCloseEvent: i
  } = _ref;
  const d = t.split("?"),
    l = ke(e, n, r),
    c = {
      auth: o,
      ua: l,
      projectId: s,
      useOnCloseEvent: i || void 0
    },
    u = Ce(d[1] || "", c);
  return d[0] + "?" + u;
}
function Gn(e) {
  let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
  const t = typeof n < "u" ? e.split("://")[1] : e;
  return n = n === "wss" ? "https" : "http", [n, t].join("://");
}
function Wn(e, n, t) {
  if (!e[n] || typeof e[n] !== t) throw new Error("Missing or invalid \"".concat(n, "\" param"));
}
function Me(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : X;
  return Ke(e.split(Ue), n);
}
function zn(e) {
  return Me(e).join(F);
}
function O(e, n) {
  return e.filter(t => n.includes(t)).length === e.length;
}
function Ke(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : X;
  return e.slice(Math.max(e.length - n, 0));
}
function Bn(e) {
  return Object.fromEntries(e.entries());
}
function Yn(e) {
  return new Map(Object.entries(e));
}
function Jn(e, n) {
  const t = {};
  return Object.keys(e).forEach(r => {
    t[r] = n(e[r]);
  }), t;
}
const Qn = e => e;
function Le(e) {
  return e.trim().replace(/^\w/, n => n.toUpperCase());
}
function Zn(e) {
  return e.split(F).map(n => Le(n)).join(F);
}
function Xn() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : le;
  let n = arguments.length > 1 ? arguments[1] : undefined;
  const t = G(e || le);
  let r, o, s;
  return {
    resolve: i => {
      s && r && (clearTimeout(s), r(i));
    },
    reject: i => {
      s && o && (clearTimeout(s), o(i));
    },
    done: () => new Promise((i, d) => {
      s = setTimeout(() => {
        d(new Error(n));
      }, t), r = i, o = d;
    })
  };
}
function et(e, n, t) {
  return new Promise(async (r, o) => {
    const s = setTimeout(() => o(new Error(t)), n);
    try {
      const i = await e;
      r(i);
    } catch (i) {
      o(i);
    }
    clearTimeout(s);
  });
}
function ne(e, n) {
  if (typeof n == "string" && n.startsWith("".concat(e, ":"))) return n;
  if (e.toLowerCase() === "topic") {
    if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
    return "topic:".concat(n);
  } else if (e.toLowerCase() === "id") {
    if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
    return "id:".concat(n);
  }
  throw new Error("Unknown expirer target type: ".concat(e));
}
function nt(e) {
  return ne("topic", e);
}
function tt(e) {
  return ne("id", e);
}
function rt(e) {
  const [n, t] = e.split(":"),
    r = {
      id: void 0,
      topic: void 0
    };
  if (n === "topic" && typeof t == "string") r.topic = t;else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);else throw new Error("Invalid target, expected id:number or topic:string, got ".concat(n, ":").concat(t));
  return r;
}
function ot(e, n) {
  return hn((n || Date.now()) + G(e));
}
function st(e) {
  return Date.now() >= G(e);
}
function it(e, n) {
  return "".concat(e).concat(n ? ":".concat(n) : "");
}
function S() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return [...new Set([...e, ...n])];
}
async function ct(_ref2) {
  let {
    id: e,
    topic: n,
    wcDeepLink: t
  } = _ref2;
  try {
    if (!t) return;
    const r = typeof t == "string" ? JSON.parse(t) : t;
    let o = r === null || r === void 0 ? void 0 : r.href;
    if (typeof o != "string") return;
    o.endsWith("/") && (o = o.slice(0, -1));
    const s = "".concat(o, "/wc?requestId=").concat(e, "&sessionTopic=").concat(n),
      i = j();
    i === b.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === b.reactNative && typeof (global == null ? void 0 : global.Linking) < "u" && (await global.Linking.openURL(s));
  } catch (r) {
    console.error(r);
  }
}
const xe = "irn";
function at(e) {
  return (e === null || e === void 0 ? void 0 : e.relay) || {
    protocol: xe
  };
}
function ut(e) {
  const n = gn[e];
  if (typeof n > "u") throw new Error("Relay Protocol not supported: ".concat(e));
  return n;
}
var dt = Object.defineProperty,
  Fe = Object.getOwnPropertySymbols,
  lt = Object.prototype.hasOwnProperty,
  ft = Object.prototype.propertyIsEnumerable,
  He = (e, n, t) => n in e ? dt(e, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[n] = t,
  pt = (e, n) => {
    for (var t in n || (n = {})) lt.call(n, t) && He(e, t, n[t]);
    if (Fe) for (var t of Fe(n)) ft.call(n, t) && He(e, t, n[t]);
    return e;
  };
function qe(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
  const t = {},
    r = "relay" + n;
  return Object.keys(e).forEach(o => {
    if (o.startsWith(r)) {
      const s = o.replace(r, ""),
        i = e[o];
      t[s] = i;
    }
  }), t;
}
function mt(e) {
  const n = e.indexOf(":"),
    t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0,
    r = e.substring(0, n),
    o = e.substring(n + 1, t).split("@"),
    s = typeof t < "u" ? e.substring(t) : "",
    i = V.parse(s);
  return {
    protocol: r,
    topic: Ge(o[0]),
    version: parseInt(o[1], 10),
    symKey: i.symKey,
    relay: qe(i)
  };
}
function Ge(e) {
  return e.startsWith("//") ? e.substring(2) : e;
}
function We(e) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
  const t = "relay",
    r = {};
  return Object.keys(e).forEach(o => {
    const s = t + n + o;
    e[o] && (r[s] = e[o]);
  }), r;
}
function yt(e) {
  return "".concat(e.protocol, ":").concat(e.topic, "@").concat(e.version, "?") + V.stringify(pt({
    symKey: e.symKey
  }, We(e.relay)));
}
var ht = Object.defineProperty,
  Et = Object.defineProperties,
  vt = Object.getOwnPropertyDescriptors,
  ze = Object.getOwnPropertySymbols,
  gt = Object.prototype.hasOwnProperty,
  bt = Object.prototype.propertyIsEnumerable,
  Be = (e, n, t) => n in e ? ht(e, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[n] = t,
  Nt = (e, n) => {
    for (var t in n || (n = {})) gt.call(n, t) && Be(e, t, n[t]);
    if (ze) for (var t of ze(n)) bt.call(n, t) && Be(e, t, n[t]);
    return e;
  },
  Ot = (e, n) => Et(e, vt(n));
function R(e) {
  const n = [];
  return e.forEach(t => {
    const [r, o] = t.split(":");
    n.push("".concat(r, ":").concat(o));
  }), n;
}
function Ye(e) {
  const n = [];
  return Object.values(e).forEach(t => {
    n.push(...R(t.accounts));
  }), n;
}
function Je(e, n) {
  const t = [];
  return Object.values(e).forEach(r => {
    R(r.accounts).includes(n) && t.push(...r.methods);
  }), t;
}
function Qe(e, n) {
  const t = [];
  return Object.values(e).forEach(r => {
    R(r.accounts).includes(n) && t.push(...r.events);
  }), t;
}
function St(e, n) {
  const t = sn(e, n);
  if (t) throw new Error(t.message);
  const r = {};
  for (const [o, s] of Object.entries(e)) r[o] = {
    methods: s.methods,
    events: s.events,
    chains: s.accounts.map(i => "".concat(i.split(":")[0], ":").concat(i.split(":")[1]))
  };
  return r;
}
function It(e) {
  const {
      proposal: {
        requiredNamespaces: n,
        optionalNamespaces: t = {}
      },
      supportedNamespaces: r
    } = e,
    o = re(n),
    s = re(t),
    i = {};
  Object.keys(r).forEach(c => {
    const u = r[c].chains,
      a = r[c].methods,
      g = r[c].events,
      P = r[c].accounts;
    u.forEach(m => {
      if (!P.some(f => f.includes(m))) throw new Error("No accounts provided for chain ".concat(m, " in namespace ").concat(c));
    }), i[c] = {
      chains: u,
      methods: a,
      events: g,
      accounts: P
    };
  });
  const d = an(n, i, "approve()");
  if (d) throw new Error(d.message);
  const l = {};
  return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach(c => {
    const u = r[c].chains.filter(m => {
        var f, h;
        return (h = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : h.includes(m);
      }),
      a = r[c].methods.filter(m => {
        var f, h;
        return (h = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : h.includes(m);
      }),
      g = r[c].events.filter(m => {
        var f, h;
        return (h = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : h.includes(m);
      }),
      P = u.map(m => r[c].accounts.filter(f => f.includes("".concat(m, ":")))).flat();
    l[c] = {
      chains: u,
      methods: a,
      events: g,
      accounts: P
    };
  }), Object.keys(s).forEach(c => {
    var u, a, g, P, m, f;
    if (!r[c]) return;
    const h = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter(T => r[c].chains.includes(T)),
      dn = r[c].methods.filter(T => {
        var w, _;
        return (_ = (w = s[c]) == null ? void 0 : w.methods) == null ? void 0 : _.includes(T);
      }),
      ln = r[c].events.filter(T => {
        var w, _;
        return (_ = (w = s[c]) == null ? void 0 : w.events) == null ? void 0 : _.includes(T);
      }),
      fn = h === null || h === void 0 ? void 0 : h.map(T => r[c].accounts.filter(w => w.includes(T))).flat();
    l[c] = {
      chains: S((g = l[c]) == null ? void 0 : g.chains, h),
      methods: S((P = l[c]) == null ? void 0 : P.methods, dn),
      events: S((m = l[c]) == null ? void 0 : m.events, ln),
      accounts: S((f = l[c]) == null ? void 0 : f.accounts, fn)
    };
  }), l);
}
function te(e) {
  return e.includes(":");
}
function Ze(e) {
  return te(e) ? e.split(":")[0] : e;
}
function re(e) {
  var n, t, r;
  const o = {};
  if (!H(e)) return o;
  for (const [s, i] of Object.entries(e)) {
    const d = te(s) ? [s] : i.chains,
      l = i.methods || [],
      c = i.events || [],
      u = Ze(s);
    o[u] = Ot(Nt({}, o[u]), {
      chains: S(d, (n = o[u]) == null ? void 0 : n.chains),
      methods: S(l, (t = o[u]) == null ? void 0 : t.methods),
      events: S(c, (r = o[u]) == null ? void 0 : r.events)
    });
  }
  return o;
}
const Pt = {
    INVALID_METHOD: {
      message: "Invalid method.",
      code: 1001
    },
    INVALID_EVENT: {
      message: "Invalid event.",
      code: 1002
    },
    INVALID_UPDATE_REQUEST: {
      message: "Invalid update request.",
      code: 1003
    },
    INVALID_EXTEND_REQUEST: {
      message: "Invalid extend request.",
      code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
      message: "Invalid session settle request.",
      code: 1005
    },
    UNAUTHORIZED_METHOD: {
      message: "Unauthorized method.",
      code: 3001
    },
    UNAUTHORIZED_EVENT: {
      message: "Unauthorized event.",
      code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
      message: "Unauthorized update request.",
      code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
      message: "Unauthorized extend request.",
      code: 3004
    },
    USER_REJECTED: {
      message: "User rejected.",
      code: 5e3
    },
    USER_REJECTED_CHAINS: {
      message: "User rejected chains.",
      code: 5001
    },
    USER_REJECTED_METHODS: {
      message: "User rejected methods.",
      code: 5002
    },
    USER_REJECTED_EVENTS: {
      message: "User rejected events.",
      code: 5003
    },
    UNSUPPORTED_CHAINS: {
      message: "Unsupported chains.",
      code: 5100
    },
    UNSUPPORTED_METHODS: {
      message: "Unsupported methods.",
      code: 5101
    },
    UNSUPPORTED_EVENTS: {
      message: "Unsupported events.",
      code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
      message: "Unsupported accounts.",
      code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
      message: "Unsupported namespace key.",
      code: 5104
    },
    USER_DISCONNECTED: {
      message: "User disconnected.",
      code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
      message: "Session settlement failed.",
      code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
      message: "Unsupported wc_ method.",
      code: 10001
    }
  },
  Tt = {
    NOT_INITIALIZED: {
      message: "Not initialized.",
      code: 1
    },
    NO_MATCHING_KEY: {
      message: "No matching key.",
      code: 2
    },
    RESTORE_WILL_OVERRIDE: {
      message: "Restore will override.",
      code: 3
    },
    RESUBSCRIBED: {
      message: "Resubscribed.",
      code: 4
    },
    MISSING_OR_INVALID: {
      message: "Missing or invalid.",
      code: 5
    },
    EXPIRED: {
      message: "Expired.",
      code: 6
    },
    UNKNOWN_TYPE: {
      message: "Unknown type.",
      code: 7
    },
    MISMATCHED_TOPIC: {
      message: "Mismatched topic.",
      code: 8
    },
    NON_CONFORMING_NAMESPACES: {
      message: "Non conforming namespaces.",
      code: 9
    }
  };
function N(e, n) {
  const {
    message: t,
    code: r
  } = Tt[e];
  return {
    message: n ? "".concat(t, " ").concat(n) : t,
    code: r
  };
}
function A(e, n) {
  const {
    message: t,
    code: r
  } = Pt[e];
  return {
    message: n ? "".concat(t, " ").concat(n) : t,
    code: r
  };
}
function C(e, n) {
  return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function H(e) {
  return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function I(e) {
  return typeof e > "u";
}
function y(e, n) {
  return n && I(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function q(e, n) {
  return n && I(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function wt(e, n) {
  const {
      requiredNamespaces: t
    } = n,
    r = Object.keys(e.namespaces),
    o = Object.keys(t);
  let s = !0;
  return O(o, r) ? (r.forEach(i => {
    const {
        accounts: d,
        methods: l,
        events: c
      } = e.namespaces[i],
      u = R(d),
      a = t[i];
    (!O(M(i, a), u) || !O(a.methods, l) || !O(a.events, c)) && (s = !1);
  }), s) : !1;
}
function D(e) {
  return y(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function Xe(e) {
  if (y(e, !1) && e.includes(":")) {
    const n = e.split(":");
    if (n.length === 3) {
      const t = n[0] + ":" + n[1];
      return !!n[2] && D(t);
    }
  }
  return !1;
}
function Rt(e) {
  if (y(e, !1)) try {
    return typeof new URL(e) < "u";
  } catch {
    return !1;
  }
  return !1;
}
function At(e) {
  var n;
  return (n = e === null || e === void 0 ? void 0 : e.proposer) == null ? void 0 : n.publicKey;
}
function Ut(e) {
  return e === null || e === void 0 ? void 0 : e.topic;
}
function _t(e, n) {
  let t = null;
  return y(e === null || e === void 0 ? void 0 : e.publicKey, !1) || (t = N("MISSING_OR_INVALID", "".concat(n, " controller public key should be a string"))), t;
}
function oe(e) {
  let n = !0;
  return C(e) ? e.length && (n = e.every(t => y(t, !1))) : n = !1, n;
}
function en(e, n, t) {
  let r = null;
  return C(n) && n.length ? n.forEach(o => {
    r || D(o) || (r = A("UNSUPPORTED_CHAINS", "".concat(t, ", chain ").concat(o, " should be a string and conform to \"namespace:chainId\" format")));
  }) : D(e) || (r = A("UNSUPPORTED_CHAINS", "".concat(t, ", chains must be defined as \"namespace:chainId\" e.g. \"eip155:1\": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: [\"eip155:1\", \"eip155:5\"] }"))), r;
}
function nn(e, n, t) {
  let r = null;
  return Object.entries(e).forEach(_ref3 => {
    let [o, s] = _ref3;
    if (r) return;
    const i = en(o, M(o, s), "".concat(n, " ").concat(t));
    i && (r = i);
  }), r;
}
function tn(e, n) {
  let t = null;
  return C(e) ? e.forEach(r => {
    t || Xe(r) || (t = A("UNSUPPORTED_ACCOUNTS", "".concat(n, ", account ").concat(r, " should be a string and conform to \"namespace:chainId:address\" format")));
  }) : t = A("UNSUPPORTED_ACCOUNTS", "".concat(n, ", accounts should be an array of strings conforming to \"namespace:chainId:address\" format")), t;
}
function rn(e, n) {
  let t = null;
  return Object.values(e).forEach(r => {
    if (t) return;
    const o = tn(r === null || r === void 0 ? void 0 : r.accounts, "".concat(n, " namespace"));
    o && (t = o);
  }), t;
}
function on(e, n) {
  let t = null;
  return oe(e === null || e === void 0 ? void 0 : e.methods) ? oe(e === null || e === void 0 ? void 0 : e.events) || (t = A("UNSUPPORTED_EVENTS", "".concat(n, ", events should be an array of strings or empty array for no events"))) : t = A("UNSUPPORTED_METHODS", "".concat(n, ", methods should be an array of strings or empty array for no methods")), t;
}
function se(e, n) {
  let t = null;
  return Object.values(e).forEach(r => {
    if (t) return;
    const o = on(r, "".concat(n, ", namespace"));
    o && (t = o);
  }), t;
}
function $t(e, n, t) {
  let r = null;
  if (e && H(e)) {
    const o = se(e, n);
    o && (r = o);
    const s = nn(e, n, t);
    s && (r = s);
  } else r = N("MISSING_OR_INVALID", "".concat(n, ", ").concat(t, " should be an object with data"));
  return r;
}
function sn(e, n) {
  let t = null;
  if (e && H(e)) {
    const r = se(e, n);
    r && (t = r);
    const o = rn(e, n);
    o && (t = o);
  } else t = N("MISSING_OR_INVALID", "".concat(n, ", namespaces should be an object with data"));
  return t;
}
function cn(e) {
  return y(e.protocol, !0);
}
function jt(e, n) {
  let t = !1;
  return n && !e ? t = !0 : e && C(e) && e.length && e.forEach(r => {
    t = cn(r);
  }), t;
}
function Ct(e) {
  return typeof e == "number";
}
function Dt(e) {
  return typeof e < "u" && typeof e !== null;
}
function Vt(e) {
  return !(!e || typeof e != "object" || !e.code || !q(e.code, !1) || !e.message || !y(e.message, !1));
}
function kt(e) {
  return !(I(e) || !y(e.method, !1));
}
function Mt(e) {
  return !(I(e) || I(e.result) && I(e.error) || !q(e.id, !1) || !y(e.jsonrpc, !1));
}
function Kt(e) {
  return !(I(e) || !y(e.name, !1));
}
function Lt(e, n) {
  return !(!D(n) || !Ye(e).includes(n));
}
function xt(e, n, t) {
  return y(t, !1) ? Je(e, n).includes(t) : !1;
}
function Ft(e, n, t) {
  return y(t, !1) ? Qe(e, n).includes(t) : !1;
}
function an(e, n, t) {
  let r = null;
  const o = Ht(e),
    s = qt(n),
    i = Object.keys(o),
    d = Object.keys(s),
    l = un(Object.keys(e)),
    c = un(Object.keys(n)),
    u = l.filter(a => !c.includes(a));
  return u.length && (r = N("NON_CONFORMING_NAMESPACES", "".concat(t, " namespaces keys don't satisfy requiredNamespaces.\n      Required: ").concat(u.toString(), "\n      Received: ").concat(Object.keys(n).toString()))), O(i, d) || (r = N("NON_CONFORMING_NAMESPACES", "".concat(t, " namespaces chains don't satisfy required namespaces.\n      Required: ").concat(i.toString(), "\n      Approved: ").concat(d.toString()))), Object.keys(n).forEach(a => {
    if (!a.includes(":") || r) return;
    const g = R(n[a].accounts);
    g.includes(a) || (r = N("NON_CONFORMING_NAMESPACES", "".concat(t, " namespaces accounts don't satisfy namespace accounts for ").concat(a, "\n        Required: ").concat(a, "\n        Approved: ").concat(g.toString())));
  }), i.forEach(a => {
    r || (O(o[a].methods, s[a].methods) ? O(o[a].events, s[a].events) || (r = N("NON_CONFORMING_NAMESPACES", "".concat(t, " namespaces events don't satisfy namespace events for ").concat(a))) : r = N("NON_CONFORMING_NAMESPACES", "".concat(t, " namespaces methods don't satisfy namespace methods for ").concat(a)));
  }), r;
}
function Ht(e) {
  const n = {};
  return Object.keys(e).forEach(t => {
    var r;
    t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach(o => {
      n[o] = {
        methods: e[t].methods,
        events: e[t].events
      };
    });
  }), n;
}
function un(e) {
  return [...new Set(e.map(n => n.includes(":") ? n.split(":")[0] : n))];
}
function qt(e) {
  const n = {};
  return Object.keys(e).forEach(t => {
    if (t.includes(":")) n[t] = e[t];else {
      const r = R(e[t].accounts);
      r === null || r === void 0 ? void 0 : r.forEach(o => {
        n[o] = {
          accounts: e[t].accounts.filter(s => s.includes("".concat(o, ":"))),
          methods: e[t].methods,
          events: e[t].events
        };
      });
    }
  }), n;
}
function Gt(e, n) {
  return q(e, !1) && e <= n.max && e >= n.min;
}
export { B as BASE10, p as BASE16, L as BASE64, Ln as COLON, X as DEFAULT_DEPTH, F as EMPTY_SPACE, b as ENV_MAP, xn as ONE_THOUSAND, Ae as REACT_NATIVE_PRODUCT, xe as RELAYER_DEFAULT_PROTOCOL, _e as SDK_TYPE, Ue as SLASH, Y as TYPE_0, U as TYPE_1, x as UTF8, Ce as appendToQueryString, Wn as assertType, It as buildApprovedNamespaces, ot as calcExpiry, Zn as capitalize, Le as capitalizeWord, Xn as createDelayedPromise, et as createExpiringPromise, $ as decodeTypeByte, Cn as decrypt, Un as deriveSymKey, Z as deserialize, Se as encodeTypeByte, jn as encrypt, it as engineEvent, Qn as enumify, he as formatAccountId, bn as formatAccountWithChain, ye as formatChainId, ne as formatExpirerTarget, tt as formatIdTarget, Tn as formatMessage, zn as formatMessageContext, We as formatRelayParams, qn as formatRelayRpcUrl, nt as formatTopicTarget, ke as formatUA, yt as formatUri, Rn as generateKeyPair, An as generateRandomBytes32, R as getAccountsChains, On as getAccountsFromNamespaces, Ee as getAddressFromAccount, Nn as getAddressesFromAccounts, Fn as getAppMetadata, ve as getChainFromAccount, ge as getChainsFromAccounts, M as getChainsFromNamespace, Sn as getChainsFromNamespaces, In as getChainsFromRequiredNamespaces, Ne as getDidAddress, K as getDidAddressSegments, be as getDidChainId, j as getEnvironment, Gn as getHttpUrl, N as getInternalError, Ve as getJavascriptID, De as getJavascriptOS, Ke as getLastItems, Pn as getNamespacedDidChainId, Ye as getNamespacesChains, Qe as getNamespacesEventsForChainId, Je as getNamespacesMethodsForChainId, Hn as getRelayClientMetadata, ut as getRelayProtocolApi, at as getRelayProtocolName, St as getRequiredNamespacesFromNamespaces, A as getSdkError, z as getUniqueValues, ct as handleDeeplinkRedirect, O as hasOverlap, _n as hashKey, $n as hashMessage, je as isBrowser, te as isCaipNamespace, an as isConformingNamespaces, st as isExpired, ee as isNode, At as isProposalStruct, $e as isReactNative, wt as isSessionCompatible, Ut as isSessionStruct, Vn as isTypeOneEnvelope, I as isUndefined, Xe as isValidAccountId, tn as isValidAccounts, on as isValidActions, C as isValidArray, D as isValidChainId, en as isValidChains, _t as isValidController, Vt as isValidErrorReason, Kt as isValidEvent, Ct as isValidId, rn as isValidNamespaceAccounts, se as isValidNamespaceActions, nn as isValidNamespaceChains, oe as isValidNamespaceMethodsOrEvents, sn as isValidNamespaces, Lt as isValidNamespacesChainId, Ft as isValidNamespacesEvent, xt as isValidNamespacesRequest, q as isValidNumber, H as isValidObject, Dt as isValidParams, cn as isValidRelay, jt as isValidRelays, kt as isValidRequest, Gt as isValidRequestExpiry, $t as isValidRequiredNamespaces, Mt as isValidResponse, y as isValidString, Rt as isValidUrl, Jn as mapEntries, Bn as mapToObj, S as mergeArrays, re as normalizeNamespaces, Yn as objToMap, W as parseAccountId, me as parseChainId, Me as parseContextNames, rt as parseExpirerTarget, Ze as parseNamespaceKey, qe as parseRelayParams, Ge as parseTopic, mt as parseUri, Ie as serialize, Dn as validateDecoding, Pe as validateEncoding };